import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import GtmService from 'static/script/app/ui/google-tagmanager-service';
import { selectShowCurrencySelection } from 'tradera-state/multi-currency';
import { selectShowRegionSelection } from 'tradera-state/shipping-region/selectors';
import { useTranslator } from 'tradera-lang/translate';
import DropdownIcon from '@tradera/blueprint/theme/icons2/dropdown.svg?jsx';
import { LocalizationMenu } from 'static/script/components/localization/localization-menu';
import HoverMenu from 'tradera-components/site-header/hover-menu/hover-menu';
import styles from './footer-localization-link.module.scss';
const trackAnalytics = visible => {
    const label = visible ? 'Open' : 'Close';
    GtmService.trackAction('Footer', 'Localization menu', label);
};

const FooterLocalizationLink = ({
    showCurrencySelection,
    showRegionSelection
}) => {
    const { t } = useTranslator();
    const [
        isLocalizationSettingsVisible,
        setLocalizationSettingsVisible
    ] = useState(false);

    const onClick = e => {
        e.preventDefault();
        const shouldBeVisible = !isLocalizationSettingsVisible;
        trackAnalytics(shouldBeVisible);
        setLocalizationSettingsVisible(shouldBeVisible);
    };

    const title = showCurrencySelection
        ? t('footer_localization_languageAndCurrency')
        : t('footer_localization_language');

    return (
        <>
            <HoverMenu
                showMenu={isLocalizationSettingsVisible}
                className={styles.hoverLocalizationMenuFooter}>
                <LocalizationMenu
                    idPrefix="site-footer"
                    onBlur={() => setLocalizationSettingsVisible(false)}
                    showCurrencySelection={showCurrencySelection}
                    showRegionSelection={showRegionSelection || false}
                />
            </HoverMenu>
            <a className="mr-2" href="#" onClick={onClick}>
                {title}
                <DropdownIcon className="icon icon-xs align-baseline ml-1" />
            </a>
        </>
    );
};

FooterLocalizationLink.propTypes = {
    showCurrencySelection: PropTypes.bool.isRequired
};

const mapStateToProps = state => ({
    showCurrencySelection: selectShowCurrencySelection(state),
    showRegionSelection: selectShowRegionSelection(state)
});

export default connect(mapStateToProps)(FooterLocalizationLink);
